// extracted by mini-css-extract-plugin
export var navBar = "styles-module--navBar--SnC22";
export var rightLinks = "styles-module--rightLinks--vMad6";
export var title = "styles-module--title--nQ5w7";
export var lastName = "styles-module--lastName--KxE0l";
export var navLink = "styles-module--navLink--GhDG+";
export var active = "styles-module--active--Ya-30";